import { useState } from "react";
import { toast } from "sonner";
import { clientApi, formatErr, fmtDate, labelOf, ALBUM_STATUSES } from "@/lib/api";

export const Block = ({ title, children, testid, aside }) => (
  <section className="grid grid-cols-12 gap-6 py-14 border-t border-pietra" data-testid={testid}>
    <div className="col-span-12 lg:col-span-3">
      <h2 className="font-serif font-light text-[32px] tracking-[-0.015em]">{title}</h2>
      {aside && <div className="mt-3 text-sm text-mute">{aside}</div>}
    </div>
    <div className="col-span-12 lg:col-span-9">{children}</div>
  </section>
);

export const AlbumStatus = ({ ev }) => {
  const idx = ALBUM_STATUSES.findIndex((s) => s.value === ev.album_status);
  return (
    <Block title="Stato della consegna" testid="client-album">
      <p className="font-serif text-2xl" data-testid="client-album-status">{labelOf(ALBUM_STATUSES, ev.album_status)}</p>
      <div className="flex gap-1 mt-5 max-w-xl">{ALBUM_STATUSES.map((s, k) => <span key={s.value} className={`h-1 flex-1 ${k <= idx ? "bg-sagedark" : "bg-pietra/60"}`} />)}</div>
      {ev.album_delivery_date && <p className="mt-5 text-sm text-stoneish">Consegna prevista: {fmtDate(ev.album_delivery_date)}</p>}
      {ev.album_notes && <p className="mt-3 text-sm text-stoneish whitespace-pre-line">{ev.album_notes}</p>}
    </Block>
  );
};

export const Questionnaire = ({ ev, reload }) => {
  const q = ev.questionnaire;
  const [answers, setAnswers] = useState(ev.questionnaire_answers || {});
  if (!q) return null;
  const save = async (e) => {
    e.preventDefault();
    try { await clientApi.post("/client/questionnaire", { answers }); toast.success("Risposte salvate"); reload(); } catch (err) { toast.error(formatErr(err)); }
  };
  return (
    <Block title="Questionario" testid="client-questionnaire" aside="Ci aiuta a preparare al meglio la giornata. Potete modificarlo quando volete.">
      <form onSubmit={save} className="space-y-6 max-w-2xl">
        {q.questions.map((qq, k) => (
          <label key={qq} className="block">
            <span className="text-[15px] text-ink">{qq}</span>
            <textarea className="field min-h-[60px] resize-y" value={answers[qq] || ""} onChange={(e) => setAnswers({ ...answers, [qq]: e.target.value })} data-testid={`client-q-${k}`} />
          </label>
        ))}
        <button className="btn-ink" data-testid="client-q-save">Salva risposte</button>
      </form>
    </Block>
  );
};
